/**
 * 输入控件常用常量
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-02-05 15:06:15
 * Version: 1.0
 * Modify log:
 */

//输入控件类型常量
export const InputType = {
    INPUT: 'input', //单行文本输入控件类型
    INPUTNUMBER: 'inputnumber', //数字输入控件类型
    TEXTAREA: 'textarea', //多行文本输入控件类型
    SELECT: 'select', //下拉选择器类型
    RADIO: 'radio', //单选框类型
    CHECKBOX: 'checkbox', //多选框类型
    SWITCH: 'switch', //开关类型
    UPLOAD: 'upload', //上传控件类型
    DATEPICKER: 'datepicker', // 日期控件
    RANGEPICKER: 'rangepicker', // 日期范围控件
    TIMEPICKER: 'timepicker', // 时间控件
    MULTISELECT: 'multiselect', // 多选下拉框
    NHCASCADER: 'nhcascader', // 级联下拉框
    DATETIMEPICKER: 'datetimepicker', // 日期时间选择框
    MONTHPICKER: 'monthpicker', // 月份选择框
    OLDUPLOAD: 'oldupload',// 旧版附件上传，没有附件主表
};

//控件宽度类型
export const WidthType = {
    DEFAULT: 'default', //默认，自适应
    RELATIVE: 'relative', //相对宽度，百分比
    FIXED: 'fixed' //固定宽度，像素
}

//正则表达式常量
export const RegularExpression = {
    NUMBER: { describe: "数字", rule: { pattern: /^[0-9]{0,}$/, message: "请输入数字" } },
    CN_CHARACTERS: { describe: "汉字", rule: { pattern: /^[\u4e00-\u9fa5]{0,}$/, message: "请输入汉字" } },
    EN_CHARACTERS: { describe: "英文", rule: { pattern: /^[A-Za-z]{0,}$/, message: "请输入英文" } },
    EN_NUMBER_UNDERLINE: { describe: "英文、数字或下划线", rule: { pattern: /^[A-Za-z0-9_]{0,}$/, message: "请输入英文、数字或下划线" } },
    EN_NUMBER: { describe: "英文或数字", rule: { pattern: /^[A-Za-z0-9]{0,}$/, message: "请输入英文或数字" } },
    EMAIL: { describe: "邮箱地址", rule: { pattern: /^([a-z0-9A-Z]+[-|_|\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,3}$/, message: "请输入正确的邮箱地址" } },
    GAT_MOBILE_PHONE_NUMBER: { describe: "联系号码", rule: { pattern: /^1\d{10}$|^([6|9])\d{7}$|^[6]([8|6])\d{5}$|^[0][9]\d{8}$/, message: "请输入正确的手机号码" } },
    MOBILE_PHONE_NUMBER: { describe: "手机号码", rule: { pattern: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))[0-9]{8}$/, message: "请输入正确的手机号码" } },
    PHONE_NUMBER: { describe: "电话号码", rule: { pattern: /^(0[0-9]{2}-[0-9]{8}(-[0-9]{1,4})?$)|(0[0-9]{3}-[0-9]{7,8}(-[0-9]{1,4})?$)/, message: "请输入正确的电话号码" } },
    IDCARD: { describe: "身份证号码", rule: { pattern: /(^[1-9]{1}[0-9]{14}$)|(^[1-9]{1}[0-9]{16}[0-9X]{1}$)/, message: "请输入正确的身份证号，字母应为大写" } },
    QQ: { describe: "QQ号码", rule: { pattern: /^[1-9][0-9]{4,15}$/, message: "请输入正确的QQ号" } },
    POSTAL_CODE: { describe: "邮政编码", rule: { pattern: /^[1-9][0-9]{5}$/, message: "请输入正确的邮政编码" } }
}

export default RegularExpression;



// WEBPACK FOOTER //
// ./components/common/NHInputPicker/input-const.js